import { render, staticRenderFns } from "./dnd-list.vue?vue&type=template&id=53b94cc0&"
import script from "./dnd-list.vue?vue&type=script&lang=js&"
export * from "./dnd-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/noblecare-backend.mindful-birthing.com.tw/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53b94cc0')) {
      api.createRecord('53b94cc0', component.options)
    } else {
      api.reload('53b94cc0', component.options)
    }
    module.hot.accept("./dnd-list.vue?vue&type=template&id=53b94cc0&", function () {
      api.rerender('53b94cc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components-demo/dnd-list.vue"
export default component.exports